import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import {routeConfig} from './routes/config';

const router = createBrowserRouter(routeConfig);

export function App() {
  return <RouterProvider router={router} />;
}
